import React, { useCallback, useMemo, useRef } from 'react'
import { RolloverSelectionPointer } from '@leverege/ui-attributes'
import { Selection } from '@leverege/ui-redux'

import SpatialDelegate from './SpatialDelegate'
import SpatialItem from './SpatialItem'

const style = {
  position : 'absolute',
  top : 0,
  left : 0,
  bottom : 0,
  right : 0
}

export default function SpatialView( props ) {
  const { imageRatios, items, selection, rollover, rolloverModel, selectionModel } = props
  
  const domRef = useRef( )
  const delegate = useMemo( () => {
    return new SpatialDelegate( { items, imageRatios } )
  }, [ imageRatios, items ] )

  const pointerController = useMemo( () => {
    return new RolloverSelectionPointer( { delegate, domRef, rolloverModel, selectionModel } )
  }, [ delegate ] )

  pointerController.setPointerContext( props )
  const onClick = useCallback( ( e ) => {
    pointerController.setPointerContext( e, { } )
    pointerController.onMouseClick( e )
  }, [ pointerController ] )

  const onContextMenu = useCallback( ( e ) => {
    pointerController.setPointerContext( e, { } )
    pointerController.onContextMenu( e )
  }, [ pointerController ] )

  const onMove = useCallback( ( e ) => {
    pointerController.setPointerContext( e, { } )
    pointerController.onMouseMove( e )
  }, [ pointerController ] )

  const onLeave = useCallback( ( e ) => {
    pointerController.setPointerContext( e, { } )
    pointerController.onMouseOut( e )
  }, [ pointerController ] )

  const hasSelectionOrRollover = useMemo( () => {
    const isRollover = items.some( ( item ) => {
      return Selection.isSelected( rollover, item.id )
    } )
    const isSelected = items.some( ( item ) => {
      return Selection.isSelected( selection, item.id )
    } )

    return isRollover || isSelected
  }, [ selection, rollover, items ] )

  return (
    <div
      style={style}
      ref={domRef}
      onClick={onClick}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      onContextMenu={onContextMenu}>
      { items.map( ( item, i ) => {
        if ( item?.data?.data?.data?.detection?.bbox == null ) { return null }
        return (
          <SpatialItem
            key={`spit-${item.id}`}
            item={item}
            selected={selection ? Selection.isSelected( selection, item.id ) : false}
            rollover={rollover ? Selection.isSelected( rollover, item.id ) : false} />
        )
      } ) }
      {pointerController && hasSelectionOrRollover && pointerController.getComponents()}
    </div>
  )
}
